// extracted by mini-css-extract-plugin
export default {"tableBody":"table_tableBody__1-5Kp","active":"table_active__TWRSN"};